import type React from 'react'

import type { SubjectBySearchResult } from '@/types/Subject'

import Subject from './Subject'

interface Props {
  applicant?: SubjectBySearchResult
}

const SubjectView: React.FC<Props> = ({ applicant }) => {
  if (!applicant) return null

  return (
    <Subject
      avatarUrl={applicant.avatar}
      name={
        applicant?.context?.name ||
        applicant?.context?.firstName + ' ' + applicant?.context?.lastName
      }
      email={applicant?.context?.email ?? ''}
      type={applicant?.type ?? 'tenant'}
      referenceTier={applicant.referenceTier}
    />
  )
}

export default SubjectView
